import BaseTabs from '../modules/tabs.js'

document.addEventListener('DOMContentLoaded', () => {
    // Инициализация табов
    new BaseTabs('door', (tab) => {
        const firstRadio = document.querySelector('.placing-order__form-payment .base-radio:nth-child(1)')
        const secondRadio = document.querySelector('.placing-order__form-payment .base-radio:nth-child(2)')
        if (firstRadio) {
            if (tab !== 'door') {
                firstRadio.classList.add('base-radio--hidden')
                secondRadio.value = true
            } else {
                firstRadio.classList.remove('base-radio--hidden')
            }
        }
    })

    // Счетчик символов для textarea
    document.querySelectorAll('.placing-order__textarea').forEach((textarea) => {
        const wrapper = textarea.closest('.placing-order__textarea-wrapper')
        if (wrapper) {
            const counter = wrapper.querySelector('.placing-order__textarea-max-container span:first-child')
            if (counter) {
                textarea.addEventListener('input', function () {
                    counter.textContent = this.value.length
                })
            }
        }
    })

    // Работа с городом (доставка до двери)
    const cityVariantsWrapper = document.querySelector('#city-variants')
    const cityInput = document.querySelector('#delivery-door-city')
    const cityCrossSvg = document.querySelector('.placing-order__inp-icon')

    if (cityInput && cityVariantsWrapper && cityCrossSvg) {
        const cityVariants = cityVariantsWrapper.querySelectorAll('.placing-order__inp-variants-item')

        cityInput.addEventListener('input', () => {
            console.log(cityInput.value)
            if (cityInput.value === '') {
                cityVariantsWrapper.classList.add('placing-order__inp-variants--hidden')
                cityCrossSvg.classList.add('placing-order__inp-icon--hidden')
            } else {
                cityVariantsWrapper.classList.remove('placing-order__inp-variants--hidden')
                cityCrossSvg.classList.remove('placing-order__inp-icon--hidden')
            }
        })

        cityCrossSvg.addEventListener('click', () => {
            cityInput.value = ''
            cityVariantsWrapper.classList.add('placing-order__inp-variants--hidden')
            cityCrossSvg.classList.add('placing-order__inp-icon--hidden')
        })

        cityVariants.forEach((item) => {
            item.addEventListener('click', () => {
                const itemValue = item.textContent
                cityInput.value = itemValue
                cityVariantsWrapper.classList.add('placing-order__inp-variants--hidden')
            })
        })
    }

    // Работа с городом (пункты выдачи)
    const cityPointsVariantWrapper = document.querySelector('#city-points-variants')
    const cityPointsInput = document.querySelector('#delivery-points-city')

    if (cityPointsInput && cityPointsVariantWrapper && cityCrossSvg) {
        const cityPointsVariants = cityPointsVariantWrapper.querySelectorAll('.placing-order__inp-variants-item')

        cityPointsInput.addEventListener('input', () => {
            if (cityPointsInput.value === '') {
                cityPointsVariantWrapper.classList.add('placing-order__inp-variants--hidden')
                cityCrossSvg.classList.add('placing-order__inp-icon--hidden')
            } else {
                cityPointsVariantWrapper.classList.remove('placing-order__inp-variants--hidden')
                cityCrossSvg.classList.remove('placing-order__inp-icon--hidden')
            }
        })

        cityPointsVariants.forEach((item) => {
            item.addEventListener('click', () => {
                const itemValue = item.textContent
                cityPointsInput.value = itemValue
                cityPointsVariantWrapper.classList.add('placing-order__inp-variants--hidden')
                cityCrossSvg.classList.add('placing-order__inp-icon--hidden')
            })
        })
    }

    // Работа с адресами пунктов выдачи
    const addressesVariantsWrapper = document.querySelector('#address-points-variants')
    const addressesPointsInput = document.querySelector('#delivery-points-address')
    const addressesArrowDown = document.querySelector('.icon-arrow-down')

    if (addressesPointsInput && addressesVariantsWrapper && addressesArrowDown && cityCrossSvg) {
        const addressesPointsVariants = addressesVariantsWrapper.querySelectorAll('.placing-order__inp-variants-item')

        addressesPointsInput.addEventListener('click', () => {
            addressesVariantsWrapper.classList.remove('placing-order__inp-variants--hidden')
            cityCrossSvg.classList.remove('placing-order__inp-icon--hidden')
            addressesArrowDown.classList.add('icon-arrow-down--active')
        })

        addressesPointsVariants.forEach((item) => {
            item.addEventListener('click', () => {
                const itemValue = item.textContent
                addressesPointsInput.value = itemValue
                addressesVariantsWrapper.classList.add('placing-order__inp-variants--hidden')
                addressesArrowDown.classList.remove('icon-arrow-down--active')
                // cityCrossSvg.classList.add('placing-order__inp-icon--hidden')
            })
        })
    }

    // Форматирование индекса (автоматический пробел)
    const indexInputs = document.querySelector('#delivery-door-index')
    if (indexInputs) {
        indexInputs.addEventListener('input', () => {
            let value = indexInputs.value.replace(/\s/g, '')
            if (value.length > 3) {
                value = value.slice(0, 3) + ' ' + value.slice(3)
            }
            indexInputs.value = value

            setTimeout(() => {
                indexInputs.setSelectionRange(indexInputs.value.length, indexInputs.value.length)
            }, 0)
        })

        // Предотвращение удаления пробела
        indexInputs.addEventListener('keydown', function (e) {
            const cursorPos = this.selectionStart

            if ((e.key === 'Backspace' || e.key === 'Delete') && this.value.length > 3 && this.value.charAt(3) === ' ') {
                if (e.key === 'Backspace' && cursorPos === 4) {
                    e.preventDefault()
                    this.setSelectionRange(3, 3)
                }

                if (e.key === 'Delete' && cursorPos === 3) {
                    e.preventDefault()
                    let value = this.value.replace(/\s/g, '')
                    value = value.slice(0, 3) + ' ' + value.slice(4)
                    this.value = value
                    this.setSelectionRange(3, 3)
                }
            }
        })
    }
})
